import React, { useState, useEffect } from 'react';
import Link from 'components/Link';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import s from './RelatedStoriesCardBottom.scss';

const RelatedStoriesCardBottom = props => {
  const { data, wrapperClass, isLeadImageNews, isCtnCpd } = props;

  const isRelatedStoriesPresent =
    data &&
    Array.isArray(data.relatedStories) &&
    data.relatedStories.length > 1;

  if (!isRelatedStoriesPresent) {
    return null;
  }
  useEffect(() => {
    if (isRelatedStoriesPresent) {
      analyticsWrapper('ga4', {
        event: 'user_shown',
        type: 'main_lineup_related_story',
        category: isLeadImageNews ? 'lead_story' : 'lineup_story',
      });
    }
  }, []);

  const expand = isCtnCpd && isLeadImageNews ? false : isLeadImageNews;

  const [relatedStoriesCollapsed, setRelatedStoriesCollapsed] = useState(
    expand,
  );

  return (
    <div
      className={`${s.relatedStoriesContainer} ${
        wrapperClass ? s[wrapperClass] : ''
      }`}
    >
      <button
        className={s.collapseToggleButton}
        onClick={() => {
          analyticsWrapper('ga4', {
            event: 'user_click',
            type: `main_lineup_related_story_${
              relatedStoriesCollapsed ? 'collapse' : 'expand'
            }`,
            category: isLeadImageNews ? 'lead_story' : 'lineup_story',
          });
          setRelatedStoriesCollapsed(!relatedStoriesCollapsed);
        }}
      >
        More Coverage
        <i
          className={relatedStoriesCollapsed ? s.closeIcon : s.collapsedIcon}
        />
      </button>
      <div
        className={`${s.storiesContainer} ${
          relatedStoriesCollapsed ? '' : s.hide
        }`}
      >
        <ul>
          {data.relatedStories.map((relatedStoryItem, index) => {
            let itemIconClass;
            if (relatedStoryItem.tn === 'liveblog') {
              itemIconClass = 'relatedLbIcon';
            }
            return (
              <li>
                <Link
                  to={relatedStoryItem.wu}
                  onClick={() => {
                    analyticsWrapper('ga4', {
                      event: 'user_click',
                      type: 'main_lineup_related_story',
                      category: isLeadImageNews ? 'lead_story' : 'lineup_story',
                      story_no: index + 1,
                    });
                  }}
                >
                  <i className={itemIconClass ? s[itemIconClass] : ''} />
                  {relatedStoryItem.hl}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default RelatedStoriesCardBottom;
